<template>
  <div>
    <div class="top-box whiteBg">
      <search-input @search="handleSearch"></search-input>
    </div>
    <div class="main-box">
      <van-pull-refresh
        v-model="isRefresh"
        :head-height="80"
        @refresh="onRefresh"
      >
        <div :style="{ height: height }">
          <van-list v-model="loading" :finished="finished" @load="onLoad">
            <div
              class="whiteBg addressItem"
              v-for="(item, index) in list"
              :key="index"
            >
              <div class="item-main flex" @click="handleChoose(item)">
                <div class="top-left">
                  <div class="item-top">{{ item.myName }} {{ item.phone }}</div>
                  <div class="address-detail">
                    {{
                      item.province + item.city + item.district + item.address
                    }}
                  </div>
                </div>
                <div class="top-right" @click.stop="toEdit(item)">
                  <van-icon name="edit" class="icon" />
                </div>
              </div>
            </div>
            <van-empty
              image="search"
              description="没有找到匹配的信息"
              v-if="list.length === 0 && searchKey !== ''"
            />
            <div class="empty" v-if="list.length === 0 && searchKey === ''">
              <div>暂无地址</div>
              <div>请点击下方按钮添加</div>
            </div>
          </van-list>
        </div>
      </van-pull-refresh>
    </div>
    <div class="footer whiteBg flex">
      <div class="placeOrder flex" @click="toAdd()">添加地址</div>
    </div>
  </div>
</template>
<script>
import searchInput from '@/components/search'
export default {
  data() {
    return {
      isRefresh: false,
      loading: false,
      finished: false,
      checked: true,
      list: [],
      height: 0,
      currentPage: 0,
      searchKey: ''
    }
  },
  components: {
    searchInput
  },
  mounted() {
    this.height = document.documentElement.clientHeight - 120 + 'px'
  },
  methods: {
    getList() {
      let params = {
        type: 1,
        pageNum: this.currentPage,
        pageSize: 10
      }
      if (this.searchKey) {
        params = Object.assign(params, { searchKey: this.searchKey })
      }
      console.log(params)
      let data = this.$Base64.encode(JSON.stringify(params))
      this.$api
        .getUserAddressList(data)
        .then(res => {
          this.loading = false
          this.isRefresh = false
          if (res.code === 0) {
            this.list = this.list.concat(res.data.rows)

            if (
              res.data.rows.length === 0 ||
              this.list.length >= res.data.totalCount
            ) {
              this.finished = true // 全部数据加载完了
            } else {
              this.finished = false
            }
          } else {
            this.finished = true
          }
        })
        .catch(() => {
          this.loading = false
          this.isRefresh = false
          this.finished = true
        })
    },
    onLoad() {
      this.currentPage++
      this.getList()
    },
    onRefresh() {
      this.currentPage = 1
      this.list = []
      this.getList()
    },
    handleSearch(form) {
      this.searchKey = form
      this.onRefresh()
    },
    toEdit(item) {
      this.$router.push({
        name: 'addresseeInfo',
        query: { addressId: item.addressId }
      })
    },
    handleChoose(item) {
      this.$store.commit('set_addresseeInfo', item)
      this.$router.go(-1)
      // window.history.go(-1)
    },
    toAdd() {
      this.$router.push({ path: '/addresseeInfo' })
    }
  }
}
</script>
<style lang="scss" scoped>
.top-box {
  padding: 0 10px 10px;
  overflow: hidden;
}
.empty {
  box-sizing: border-box;
  height: 100%;
  padding-top: 30vh;
  text-align: center;
}
.main-box {
  padding: 10px;
  .item-main {
    padding-bottom: 5px;
  }
  .addressItem {
    padding: 15px 15px 10px;
    margin-bottom: 10px;
    .certified {
      display: inline-block;
      padding: 4px;
      background-color: #7f7f7f;
      color: #fff;
      font-size: 12px;
      border-radius: 4px;
    }
    .top-left {
      flex: 1;
      .address-detail {
        word-break: break-all;

        font-size: 14px;
        margin-top: 4px;
        color: #555;
      }
    }
    .top-right {
      margin-left: 5px;
      .icon {
        font-size: 26px !important;
      }
    }
  }
}
.footer {
  position: fixed;
  width: 100%;
  bottom: 0px;
  height: 54px;
  .placeOrder {
    width: calc(100% - 20px);
    height: 44px;
    border-radius: 22px;
    color: #fff;
    background-color: #a30014;
  }
}
.van-pull-refresh {
  height: calc(100vh - 120px) !important;
  overflow: auto !important;
}
</style>
